import React, { useState } from "react";
import { Input, Form, Tooltip } from "antd";
import { EyeInvisibleOutlined, EyeOutlined, InfoCircleOutlined } from '@ant-design/icons';

interface TextInputProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  title: string;
  placeholder: string;
  type?: string;
  style?: React.CSSProperties;
  required?: boolean;
  rules?: object[];
  name?: string;
  prefix?: React.ReactNode;
  tooltipText?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  inputValue,
  setInputValue,
  title,
  placeholder,
  type = "text",
  style,
  required = false,
  rules = [],
  name,
  prefix,
  tooltipText,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-1.5">
        <label 
          className="text-sm font-medium text-[#005D6E]"
          htmlFor={name}
        >
          {title} {required && <span className="text-[#75A7AD] ml-0.5">*</span>}
        </label>
        
        {tooltipText && (
          <Tooltip title={tooltipText} placement="right">
            <InfoCircleOutlined 
              className="text-[#75A7AD] cursor-help text-xs"
            />
          </Tooltip>
        )}
      </div>

      <Form.Item
        name={name}
        rules={rules.length ? rules : [{ required, message: `${title} is required` }]}
        className="mb-1"
      >
        <Input
          id={name}
          className="rounded-full border-1.8 border-[#75A7AD]"
          style={{ 
            fontSize: "16px", 
            height: "44px",
            ...style,
            // Override focus styles to prevent blue border
            boxShadow: "none",
          }}
          value={inputValue}
          placeholder={placeholder}
          onChange={handleChange}
          // Remove focus/blur handlers since we don't want to change border on focus
          type={isPasswordVisible && type === "password" ? "text" : type}
          prefix={prefix}
          suffix={
            type === "password" ? (
              <span
                onClick={togglePasswordVisibility}
                className="cursor-pointer text-gray-400 hover:text-[#005D6E]"
              >
                {isPasswordVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </span>
            ) : null
          }
        />
      </Form.Item>
    </div>
  );
};

export default TextInput;